import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { useSelectedColorFeatures } from '../../../../../hooks/features/useSelectedColorFeatures';
import IFeaturesList from '../../../../../model/IFeaturesList';
import FeatureColorList from '../../features/featureColor/featureColorList/FeatureColorList';
import FeatureColorName from '../../features/featureColor/featureColorName/FeatureColorName';
import ICategoryAttributes from '../../../../../model/ICategoryAttributes';
import ColorAttributeDataLayer from '../../../../../../common/utils/dataLayer/graphql/colorAttributeDataLayer';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';
import useDxpDataLayer from '../../../../../../common/hooks/useDxpDataLayer';

export interface ILayoutOneProps {
  featuresList: IFeaturesList;
  categoryAttributes?: ICategoryAttributes;
}

const LayoutOne: FC<ILayoutOneProps> = ({ featuresList, categoryAttributes }) => {
  const { colorSelectionCode, colorSelectionName, handleColorSelection } = useSelectedColorFeatures(featuresList);
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const colorSelectionPrice = featuresList.features?.find(feature => feature.code === colorSelectionCode)?.prices[0];
  const { dxpHandleColorSelection } = useDxpDataLayer();

  const onColorSelection = (value: string, category?: string, featureName?: string) => {
    handleColorSelection(value);
    ColorAttributeDataLayer(featuresList, value, dimensions);
    dxpHandleColorSelection(category, featureName);
  };

  return (
    <Box display="flex" flexDirection="column">
      <FeatureColorName title={colorSelectionName} price={colorSelectionPrice?.money} featureId={colorSelectionCode} />
      <FeatureColorList
        features={featuresList.features}
        onClick={onColorSelection}
        selectedCode={colorSelectionCode}
        categoryAttributes={categoryAttributes}
      />
    </Box>
  );
};

export default LayoutOne;
